import { Dispatch } from 'redux';
import {
    searchLogTs,
    searchLogTsAll, 
} from '../services/logTService';
import {
    LogtActionTypes,
    LogtActions,
    SearchLogtErrorAction,
    SearchLogtSuccessAction,
    SearchLogtAllSuccessAction,
    SearchLogtAllErrorAction,
    ClearLogtAction
} from '../types/logTTypes';
import { LogtSearchCriteria } from '../models/logTSearchCriteria';

// Clear all logT records from store
export const clearLogTsAction = () => (dispatch: Dispatch<LogtActions>) => {
    dispatch<ClearLogtAction>({ type: LogtActionTypes.CLEAR_LOGT });
};

// Search LogT with criteria
export const searchLogTsAction = (page: number, limit: number, searchCriteria: LogtSearchCriteria,accessToken:string) => async (dispatch: Dispatch<LogtActions>) => {
    try {
        const data = await searchLogTs(page, limit, searchCriteria,accessToken);
        dispatch<SearchLogtSuccessAction>({
            type: LogtActionTypes.SEARCH_LOGT_SUCCESS,
            payload: data
        });
    } catch (error: any) {
        dispatch<SearchLogtErrorAction>({
            type: LogtActionTypes.SEARCH_LOGT_ERROR,
            error: error.message
        });
    }
};

// Searching all LogT entries with criteria
export const searchLogTsAllAction = (searchCriteria: LogtSearchCriteria, accessToken?: string) => async (dispatch: Dispatch<LogtActions>) => {
    try {
        const data = await searchLogTsAll(searchCriteria, accessToken);
        dispatch<SearchLogtAllSuccessAction>({
            type: LogtActionTypes.SEARCH_LOGT_ALL_SUCCESS,
            payload: data,
        });
        return data; // Ensure that data is returned here
    } catch (error: any) {
        dispatch<SearchLogtAllErrorAction>({
            type: LogtActionTypes.SEARCH_LOGT_ALL_ERROR,
            error: error.message,
        });
        throw error; // Re-throw the error if needed for further error handling
    }
};
export { searchLogTsAll };

